/* ExhibitTown theme script: the parts of the preview site (site/index.html) that run in the browser.
   Cart drawer, product option picker and product extras, collection filters and sorting, tabs, gallery,
   related products and quote prefill. window.ET comes from layout/theme.liquid.
   Product extras Shopify doesn't store (specs, lead times, freight, tiers, add-ons, line names) are in
   assets/et-data-N.json, written by scripts/theme_data.py. */
(() => {
  'use strict';
  const ET = window.ET || { routes: {}, data: [] };
  const R = Object.assign({ root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, ET.routes);
  const ROOT = R.root.replace(/\/?$/, '/');
  const QUOTE = ET.quoteUrl || '/pages/contact';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const money = n => '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const moneyShort = n => '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  const store = {
    get(k) { try { return JSON.parse(sessionStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* private mode */ } },
  };
  const NOIMG = '<div class="noimg"><svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linejoin="round" aria-hidden="true"><rect x="6" y="6" width="36" height="30" rx="2"/><path d="M14 42h20M24 36v6"/></svg></div>';

  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast.t); toast.t = setTimeout(() => { t.hidden = true; }, 2200);
  }

  /* ---------- Product extras (assets/et-data-N.json) ---------- */
  const dataCache = {};
  // Same bucket as scripts/theme_data.py: sum of the handle's character codes, mod the number of files.
  function bucket(h) { let s = 0; for (const c of h) s += c.codePointAt(0); return s % (ET.data.length || 16); }
  function productData(handle) {
    const url = ET.data && ET.data[bucket(handle)];
    if (!url) return Promise.resolve({});
    dataCache[url] = dataCache[url] || fetch(url).then(r => (r.ok ? r.json() : {})).catch(() => ({}));
    return dataCache[url].then(d => d[handle] || {});
  }

  /* ---------- Cart ---------- */
  const cartLayer = () => document.getElementById('cartLayer');
  function setCount(n) { $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; }); }
  // Swap in a fresh copy of the drawer from the section rendering API.
  function swapDrawer(html) {
    const old = cartLayer(); if (!html || !old) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cartLayer');
    if (!fresh) return;
    old.innerHTML = fresh.innerHTML;
    old.dataset.itemCount = fresh.dataset.itemCount;
    setCount(parseInt(fresh.dataset.itemCount, 10) || 0);
  }
  let lastFocus = null;
  function openCart(open) {
    const l = cartLayer(); if (!l) return false;
    if (open) {
      lastFocus = document.activeElement;
      l.hidden = false;
      const b = $('button[data-cart-close]', l); if (b) b.focus();
    } else {
      l.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    return true;
  }
  async function cartPost(path, body, json) {
    const r = await fetch(path, {
      method: 'POST',
      headers: json ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: json ? JSON.stringify(body) : body,
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(j.description || j.message || "Sorry, that didn't work. Please try again.");
    return j;
  }
  async function changeLine(line, quantity) {
    const j = await cartPost(R.cartChange + '.js', { line, quantity, sections: 'et-cart-drawer', sections_url: location.pathname }, true);
    swapDrawer(j.sections && j.sections['et-cart-drawer']);
    if (document.body.classList.contains('tpl-cart')) location.reload();
  }
  async function addToCart(fd) {
    fd.append('sections', 'et-cart-drawer');
    fd.append('sections_url', location.pathname);
    const j = await cartPost(R.cartAdd + '.js', fd, false);
    swapDrawer(j.sections && j.sections['et-cart-drawer']);
    return j;
  }

  document.addEventListener('click', e => {
    const open = e.target.closest('[data-cart-open]');
    if (open && !document.body.classList.contains('tpl-cart')) { if (openCart(true)) e.preventDefault(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); openCart(false); return; }
    const q = e.target.closest('#cartLayer [data-qty-line]');
    if (q) {
      e.preventDefault();
      const l = cartLayer(); l.setAttribute('aria-busy', 'true');
      changeLine(+q.dataset.qtyLine, +q.dataset.qty)
        .catch(err => toast(err.message))
        .finally(() => { l.removeAttribute('aria-busy'); const b = $('button[data-cart-close]', l); if (b && !l.contains(document.activeElement)) b.focus(); });
    }
  });
  document.addEventListener('keydown', e => {
    const l = cartLayer();
    if (e.key === 'Escape' && l && !l.hidden) openCart(false);
  });

  /* ---------- Product page ---------- */
  function initProduct(el) {
    const json = $('[data-product-json]', el); if (!json) return;
    let P; try { P = JSON.parse(json.textContent); } catch (e) { return; }
    const handle = el.dataset.handle || P.handle;
    const form = $('[data-add-form]', el);
    const sel = form && $('select[name="id"]', form);
    const names = (P.options || []).map(o => (typeof o === 'string' ? o : o.name));
    const single = P.variants.length < 2;
    const vals = v => v.options || [v.option1, v.option2, v.option3].filter(x => x != null);
    // Quote products have no cart form, so their starting option comes from ?variant= (as Shopify's own selection does).
    const urlVariant = new URLSearchParams(location.search).get('variant');
    let cur = (sel && P.variants.find(v => String(v.id) === sel.value)) || P.variants.find(v => String(v.id) === urlVariant)
      || P.variants.find(v => v.available) || P.variants[0];
    let opts = vals(cur).slice();
    let D = {};
    const ex = v => (D.v && D.v[v.title]) || {};
    const qtyInput = () => $('[data-qty]', el);
    const minQ = () => ex(cur).mq || 1;
    const curQty = () => Math.max(1, parseInt(qtyInput() ? qtyInput().value : '1', 10) || 1);
    const quoteHref = () => `${QUOTE}?product=${encodeURIComponent(handle)}${single ? '' : '&variant=' + cur.id}`;

    function optionValues(i) {
      // Only offer values that exist alongside the choices made in the earlier options.
      const s = [];
      P.variants.forEach(v => { const o = vals(v); if (o.slice(0, i).every((x, k) => x === opts[k]) && o[i] != null && !s.includes(o[i])) s.push(o[i]); });
      return s;
    }
    function renderPicker() {
      const box = $('[data-picker]', el); if (!box || single) return;
      box.className = 'buy'; box.style.gap = '14px';
      box.innerHTML = names.map((name, i) => {
        const vs = optionValues(i);
        if (vs.length > 12 || vs.some(x => x.length > 34)) {
          return `<label class="opt"><span>${esc(name)} <span class="muted" style="font-weight:400">(${vs.length} choices)</span></span><select data-opt="${i}">${vs.map(x => `<option value="${esc(x)}"${opts[i] === x ? ' selected' : ''}>${esc(x)}</option>`).join('')}</select></label>`;
        }
        return `<div class="opt" role="radiogroup" aria-label="${esc(name)}"><span>${esc(name)}</span><div class="seg">${vs.map(x => `<label><input type="radio" form="et-no-form" name="et-opt-${i}" data-opt="${i}" value="${esc(x)}"${opts[i] === x ? ' checked' : ''}><span>${esc(x)}</span></label>`).join('')}</div></div>`;
      }).join('');
    }
    function selectOption(i, val) {
      opts[i] = val;
      const score = v => vals(v).filter((x, k) => x === opts[k]).length;
      const c = P.variants.filter(v => vals(v)[i] === val).sort((a, b) => score(b) - score(a) || Number(b.available) - Number(a.available))[0];
      if (c) { cur = c; opts = vals(c).slice(); }
      renderPicker(); refresh(true);
    }

    function unitPrice(qty) {
      let u = cur.price / 100;
      const tr = ex(cur).tr;
      if (ET.showQtyBreaks && tr) tr.forEach(([m, pr]) => { if (qty >= m) u = pr; });
      return u;
    }
    function renderPrice() {
      const box = $('[data-price-box]', el); if (!box || !form) return;
      const qty = curQty(), e = ex(cur), tr = e.tr || [];
      let tiers = '';
      if (ET.showQtyBreaks && tr.length > 1) {
        tiers = `<div class="tiers" aria-label="Quantity pricing">${tr.map(([a, pr], i) => {
          const b = tr[i + 1] ? tr[i + 1][0] - 1 : null;
          return `<span class="${qty >= a && (b == null || qty <= b) ? 'on' : ''}">${a}${b == null ? '+' : b > a ? '–' + b : ''}: ${money(pr)}</span>`;
        }).join('')}</div>`;
      }
      const notes = [];
      if (minQ() > 1) notes.push(`Minimum order ${minQ()}`);
      if (ET.showLeadTimes) {  // theme setting show_lead_times; off for now
        if (e.ld) notes.push(`Ships in about ${e.ld} business day${e.ld === 1 ? '' : 's'} after proof approval`);
        else if (D.lt) notes.push(`Lead time: ${esc(D.lt)}`);
      }
      const vol = !ET.showQtyBreaks && tr.length > 1
        ? `<span class="muted" style="font-size:.88rem">Ordering ${tr[1][0]} or more? <a href="${esc(quoteHref())}">Ask for volume pricing</a>.</span>` : '';
      box.innerHTML = `<div class="big"><span data-price>${money(unitPrice(qty))}</span> <small>each${qty > 1 ? ` at qty ${qty}` : ''}</small></div>${tiers}`
        + (notes.length ? `<span class="muted" style="font-size:.88rem;margin-top:4px">${notes.join(' · ')}</span>` : '') + vol;
    }
    function renderShip() {
      const sn = $('[data-ship-note]', el); if (!sn || !form) return;
      const icon = sn.querySelector('svg') ? sn.querySelector('svg').outerHTML : '';
      sn.innerHTML = icon + (ex(cur).f
        ? "<span><b>Ships by freight truck.</b> Freight isn't charged at checkout; we'll email a freight quote for you to approve before it ships.</span>"
        : '<span><b>Ships by UPS or FedEx Ground.</b> Shipping is calculated at checkout from the package weight and your address.</span>');
    }
    function renderSpecs() {
      const box = $('[data-specs]', el); if (!box) return;
      const e = ex(cur), rows = (e.sp || []).slice(), code = e.c || cur.sku;
      if (code) rows.unshift(['Item code', code]);
      box.innerHTML = rows.length ? `<div class="table-scroll"><table class="spec kv">${rows.map(([k, x]) => `<tr><th>${esc(k)}</th><td${k === 'Item code' ? ' class="mono"' : ''}>${esc(x)}</td></tr>`).join('')}</table></div>` : '';
    }
    // Graphic templates (et-data "tp": a file name in Content > Files) for the selected option, and all of them on the Artwork tab.
    const tplLink = tp => `<a href="${esc((ET.filesBase || '') + tp)}" target="_blank" rel="noopener" download>${tp.endsWith('.zip') ? 'Download the templates (ZIP)' : 'Download the template (PDF)'}</a>`;
    function renderTemplate() {
      const box = $('[data-template]', el); if (!box) return;
      const tp = ex(cur).tp;
      box.hidden = !tp;
      box.innerHTML = tp ? `Graphic template for this option: ${tplLink(tp)}` : '';
    }
    function renderTemplateList() {
      const box = $('[data-template-list]', el); if (!box || !D.v) return;
      const by = {};
      P.variants.forEach(v => { const tp = ex(v).tp; if (tp) (by[tp] = by[tp] || []).push(vals(v)[0] || v.title); });
      const tps = Object.keys(by); if (!tps.length) return;
      box.innerHTML = `<h3>Graphic templates</h3><p>Build your artwork on the template for your size, then send it to us.</p><ul>${tps.map(tp => {
        const sizes = [...new Set(by[tp])];
        return `<li>${single || tps.length === 1 ? '' : esc(sizes.join(', ')) + ': '}${tplLink(tp)}</li>`;
      }).join('')}</ul>`;
      box.hidden = false;
    }
    function showImage(id) {
      const b = $(`[data-img="${id}"]`, el); if (!b) return;
      const img = $('[data-main-img] img', el);
      if (img && b.dataset.src) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = b.dataset.src; }
      $$('[data-img]', el).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
    }
    function refresh(fromUser) {
      if (sel) sel.value = String(cur.id);
      const q = qtyInput(); if (q && curQty() < minQ()) q.value = minQ();
      renderSpecs(); renderShip(); renderPrice(); renderTemplate();
      const add = $('[data-add]', el);
      if (add) { add.disabled = !cur.available; add.textContent = cur.available ? 'Add to cart' : 'Sold out'; }
      const ql = $('[data-quote-link]', el); if (ql) ql.href = quoteHref();
      if (fromUser && cur.featured_media) showImage(cur.featured_media.id);
      if (fromUser && !single) { try { const u = new URL(location.href); u.searchParams.set('variant', cur.id); history.replaceState(history.state, '', u); } catch (e) { /* ignore */ } }
    }
    function renderExtras() {
      const ln = $('[data-line-name]', el);
      if (ln && (D.l || D.s)) ln.textContent = (D.l || ln.textContent.trim()) + (D.s ? ' · ' + D.s : '');
      const tg = $('[data-tagline]', el); if (tg && D.t) { tg.textContent = D.t; tg.hidden = false; }
      const pg = $('[data-pick-group]', el);
      if (pg && D.pg) {
        pg.textContent = '· ' + D.pg[1];
        const a = pg.closest('a'), h = a && a.getAttribute('href');
        if (h && h !== '#') a.setAttribute('href', h.split('#')[0] + '#rec-' + D.pg[0]);
      }
      if (D.a && D.a.length) {
        const box = $('[data-addons]', el);
        if (box) {
          box.innerHTML = `<fieldset class="addons"><legend>Add-ons</legend>${D.a.map(([l, c, pr]) => `<div class="addon-row">${esc(l)}${pr != null ? ` <b>+${money(pr)}</b>` : ''} ${c ? `<span class="mono muted">${esc(c)}</span>` : ''}</div>`).join('')}<span class="muted" style="font-size:.86rem">Want one of these? <a href="${esc(quoteHref())}">Ask us to add it</a> and we'll include it with your order.</span></fieldset>`;
        }
        const tab = $('[data-tab="addons"]', el), panel = $('[data-panel="addons"]', el);
        if (tab && panel) {
          tab.hidden = false;
          panel.innerHTML = `<div class="table-scroll"><table class="spec"><thead><tr><th>Add-on</th><th>Item code</th>${D.a.some(a => a[2] != null) ? '<th>Price</th>' : ''}</tr></thead><tbody>${D.a.map(([l, c, pr]) => `<tr><td>${esc(l)}</td><td class="mono">${esc(c || '—')}</td>${D.a.some(a => a[2] != null) ? `<td>${pr != null ? money(pr) : '—'}</td>` : ''}</tr>`).join('')}</tbody></table></div>`;
        }
      }
      // Sizes tab: add each option's specs as columns, as on the preview site.
      const tbl = $('[data-sizes-table]', el);
      if (tbl && D.v) {
        const keys = [];
        Object.values(D.v).forEach(e => (e.sp || []).forEach(([k]) => { if (!keys.includes(k)) keys.push(k); }));
        const hr = tbl.tHead && tbl.tHead.rows[0];
        if (hr) keys.forEach(k => { const th = document.createElement('th'); th.textContent = k; hr.appendChild(th); });
        $$('tbody tr[data-vt]', tbl).forEach(tr => {
          const e = D.v[tr.dataset.vt] || {}, sp = Object.fromEntries(e.sp || []);
          const codeCell = tr.cells[1]; if (codeCell && e.c && codeCell.textContent.trim() === '—') codeCell.textContent = e.c;
          keys.forEach(k => { const td = document.createElement('td'); td.textContent = sp[k] || ''; tr.appendChild(td); });
        });
      }
    }

    // Wire up. The plain variant dropdown stays in the form (hidden) so the form still posts the right id.
    if (!single) { const fb = $('[data-fallback-picker]', el); if (fb) fb.hidden = true; }
    renderPicker();
    refresh(false);
    productData(handle).then(d => { D = d; renderExtras(); renderTemplateList(); refresh(false); });

    el.addEventListener('change', e => {
      const o = e.target.closest('[data-opt]');
      if (o) { selectOption(+o.dataset.opt, o.value); return; }
      if (e.target.matches('[data-qty]')) { if (curQty() < minQ()) e.target.value = minQ(); renderPrice(); }
    });
    el.addEventListener('input', e => { if (e.target.matches('[data-qty]')) renderPrice(); });
    el.addEventListener('click', e => {
      const st = e.target.closest('[data-step]');
      if (st) { const q = qtyInput(); q.value = Math.max(minQ(), curQty() + Number(st.dataset.step)); renderPrice(); return; }
      const th = e.target.closest('[data-img]');
      if (th) { showImage(th.dataset.img); return; }
      const tb = e.target.closest('[data-tab]');
      if (tb) {
        $$('[data-tab]', el).forEach(x => x.setAttribute('aria-selected', String(x === tb)));
        $$('[data-panel]', el).forEach(p => { p.hidden = p.dataset.panel !== tb.dataset.tab; });
      }
    });
    if (form) {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const btn = $('[data-add]', form), msg = $('[data-add-msg]', form);
        const q = qtyInput(); if (q && curQty() < minQ()) q.value = minQ();
        if (btn) btn.disabled = true;
        try {
          const fd = new FormData(form);
          Array.from(fd.keys()).forEach(k => { if (k.startsWith('et-opt-') || (k.startsWith('properties[') && !String(fd.get(k)).trim())) fd.delete(k); });
          fd.set('id', cur.id);
          fd.set('quantity', curQty());
          // Freight items carry a hidden line property so the cart and the order show "Freight quoted separately".
          if (ex(cur).f) fd.set('properties[_freight]', 'Quoted separately');
          await addToCart(fd);
          if (msg) msg.hidden = true;
          toast('Added to cart');
        } catch (err) {
          if (msg) { msg.textContent = err.message; msg.hidden = false; }
        }
        if (btn) btn.disabled = !cur.available;
      });
    }
  }

  /* ---------- Collection filters ---------- */
  // Category order and labels follow the preview site (catalog.json "categories"); Shopify's product type is the label.
  const CATS = ['Banner Stands', 'Fabric Backwalls', 'Pop-Up Displays', 'Backlit & Light Boxes', 'Booth Kits', 'Island Exhibits', 'Hanging Signs', 'Towers & Structures', 'Tabletop Displays', 'Table Throws', 'Tents, Flags & Outdoor', 'Counters & Kiosks', 'Accessories', 'Wall Signs', 'Retail Fixtures', 'Promotional Products'];
  const BOOTHS = [['booth-tabletop', 'Tabletop'], ['booth-10x10', '10x10'], ['booth-10x20', '10x20'], ['booth-island', '20x20 & up']];
  // Size bins (scripts/sizes.py via the size-... tags), small to large.
  const SIZES = [['size-under-2-ft', 'Under 2 ft'], ['size-2-ft', '2 ft'], ['size-3-ft', '3 ft'], ['size-4-ft', '4 ft'], ['size-5-ft', '5 ft'], ['size-6-ft', '6 ft'], ['size-7-8-ft', '7–8 ft'], ['size-9-10-ft', '9–10 ft'], ['size-11-16-ft', '11–16 ft'], ['size-17-22-ft', '17–22 ft'], ['size-23-ft-and-up', '23 ft and up']];
  const has = p => !p.q && !p.s;
  const PRICE_BANDS = [
    ['u250', 'Under $250', p => has(p) && p.p < 25000],
    ['250', '$250 – $1,000', p => has(p) && p.p >= 25000 && p.p < 100000],
    ['1000', '$1,000 – $5,000', p => has(p) && p.p >= 100000 && p.p < 500000],
    ['5000', '$5,000 and up', p => has(p) && p.p >= 500000],
    ['soon', 'Pricing available soon', p => !has(p)],
  ];
  const label = (list, k) => (list.find(x => x[0] === k) || [k, k])[1];

  function cardHTML(p) {
    const chips = BOOTHS.filter(([t]) => p.b.includes(t)).map(([, l]) => `<span class="chip">${esc(l)}</span>`);
    if (p.bl) chips.push('<span class="chip">Backlit</span>');
    const meta = p.n > 1 ? `${p.n} sizes &amp; options` : p.k ? 'Item ' + esc(p.k) : '';
    const price = p.q ? '<span class="price">Priced by quote</span>' : p.s ? '<span class="price">Pricing available soon</span>'
      : `<span class="price has">${p.n > 1 ? '<small>from</small> ' : ''}${moneyShort(p.p / 100)}</span>`;
    return `<a class="card" href="${esc(p.u)}">${p.pk ? '<span class="pick-badge">ExhibitTown Pick</span>' : ''}<div class="ph">${p.i ? `<img src="${esc(p.i)}" alt="${esc(p.t)}" loading="lazy" width="450" height="450">` : NOIMG}</div>`
      + `<div class="body"><span class="meta">${esc(p.l || p.ty)}</span><h3>${esc(p.t)}</h3>${chips.length ? `<div class="chips">${chips.slice(0, 3).join('')}</div>` : ''}<span class="meta">${meta}</span>${price}</div></a>`;
  }

  function initShop(el) {
    const url = el.dataset.url;
    const filters = $('[data-filters]', el), active = $('[data-active]', el), sortSel = $('[data-sort]', el), results = $('[data-results]', el);
    const details = $('details', el);
    const KEY = 'et-shop:' + url;
    const saved = store.get(KEY) || {};
    const st = { ty: saved.ty || [], b: saved.b || [], z: saved.z || [], price: saved.price || [], line: saved.line || [], sort: saved.sort || 'featured', shown: saved.shown || 24 };
    let all = null;
    if (matchMedia('(max-width: 980px)').matches && details) details.open = false;

    const tests = {
      ty: (p, k) => p.ty === k,
      b: (p, k) => p.b.includes(k),
      z: (p, k) => p.z.includes(k),
      price: (p, k) => { const b = PRICE_BANDS.find(x => x[0] === k); return !!b && b[2](p); },
      line: (p, k) => p.l === k,
    };
    const pass = (p, skip) => Object.keys(tests).every(key => key === skip || !st[key].length || st[key].some(k => tests[key](p, k)));
    const filtered = skip => all.filter(p => pass(p, skip));

    function group(key, title, entries) {
      const f = filtered(key);
      const rows = entries.map(([k, l, test]) => [k, l, f.filter(test).length]).filter(r => r[2] || st[key].includes(r[0]));
      if (rows.length < 2 && !st[key].length) return '';
      return `<div class="fgroup"><h4>${title}</h4>${rows.map(([k, l, c]) => `<label><input type="checkbox" data-f="${key}" value="${esc(k)}"${st[key].includes(k) ? ' checked' : ''}> ${esc(l)}<span>${c}</span></label>`).join('')}</div>`;
    }
    function renderFilters() {
      const types = CATS.concat([...new Set(all.map(p => p.ty))].filter(t => t && !CATS.includes(t)).sort());
      const lineCounts = {};
      filtered('line').forEach(p => { if (p.l) lineCounts[p.l] = (lineCounts[p.l] || 0) + 1; });
      const lines = Object.keys(lineCounts).concat(st.line.filter(l => !lineCounts[l]))
        .sort((a, b) => (lineCounts[b] || 0) - (lineCounts[a] || 0) || a.localeCompare(b)).slice(0, 40);
      filters.innerHTML = group('ty', 'Category', types.map(t => [t, t, p => p.ty === t]))
        + group('b', 'Booth size', BOOTHS.map(([k, l]) => [k, l, p => p.b.includes(k)]))
        + group('z', 'Size', SIZES.map(([k, l]) => [k, l, p => p.z.includes(k)]))
        + group('price', 'Price', PRICE_BANDS.map(([k, l, t]) => [k, l, t]))
        + group('line', 'Product line', lines.map(l => [l, l, p => p.l === l]));
    }
    function sorted(list) {
      const s = st.sort;
      if (s === 'az') return list.sort((a, b) => a.t.localeCompare(b.t));
      if (s === 'sizes') return list.sort((a, b) => b.n - a.n);
      if (s === 'low') return list.sort((a, b) => (has(a) ? a.p : Infinity) - (has(b) ? b.p : Infinity));
      if (s === 'high') return list.sort((a, b) => (has(b) ? b.p : -1) - (has(a) ? a.p : -1));
      if (s === 'dimlow' || s === 'dimhigh') {
        // Sort on the sizes inside the ticked Size bins, so a stand filtered to 3 ft sorts as a 3 ft stand.
        const low = s === 'dimlow';
        const key = p => {
          const idx = p.z.filter(z => !st.z.length || st.z.includes(z)).map(z => SIZES.findIndex(x => x[0] === z)).filter(i => i >= 0);
          return idx.length ? (low ? Math.min(...idx) : Math.max(...idx)) : null;
        };
        return list.sort((a, b) => { const x = key(a), y = key(b); return x == null ? (y == null ? 0 : 1) : y == null ? -1 : low ? x - y : y - x; });
      }
      return list.sort((a, b) => (b.i ? 1 : 0) - (a.i ? 1 : 0));
    }
    function renderResults() {
      const list = sorted(filtered());
      const chips = [];
      [['ty', k => k], ['b', k => label(BOOTHS, k)], ['z', k => label(SIZES, k)], ['price', k => label(PRICE_BANDS, k)], ['line', k => k]]
        .forEach(([key, lab]) => st[key].forEach(v => chips.push(`<button type="button" data-rm="${key}" data-v="${esc(v)}" aria-label="Remove filter ${esc(lab(v))}">${esc(lab(v))} ✕</button>`)));
      active.innerHTML = `<span class="muted" style="font-size:.9rem">${list.length} product${list.length === 1 ? '' : 's'}</span>` + chips.join('');
      sortSel.value = st.sort;
      results.innerHTML = list.length
        ? `<div class="grid">${list.slice(0, st.shown).map(cardHTML).join('')}</div>${list.length > st.shown ? `<div class="more"><button type="button" class="btn btn-ghost" data-more>Show ${Math.min(24, list.length - st.shown)} more of ${list.length - st.shown}</button></div>` : ''}`
        : `<div class="empty"><h3>Nothing matches all of those filters</h3><p class="muted">Clear a filter, or tell us what you need and we'll find it.</p><div style="display:flex;gap:10px;flex-wrap:wrap;justify-content:center"><a class="btn btn-ghost" href="${ROOT}collections/all">See all products</a><a class="btn btn-primary" href="${esc(QUOTE)}">Ask us to find it</a></div></div>`;
      store.set(KEY, st);
    }
    function render() { renderFilters(); renderResults(); }

    async function load() {
      const get = n => fetch(`${url}?view=data&page=${n}`, { credentials: 'same-origin' }).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); }).then(t => JSON.parse(t));
      const first = await get(1);
      const rest = first.pages > 1 ? await Promise.all(Array.from({ length: first.pages - 1 }, (_, i) => get(i + 2))) : [];
      all = first.products.concat(...rest.map(r => r.products));
      render();
      el.classList.add('is-live');
    }
    // Until the full list loads, the server-rendered first page (with page links) stays as it is.
    load().catch(() => { if (filters) filters.closest('aside').hidden = true; });

    el.addEventListener('change', e => {
      if (!all) return;
      const f = e.target.closest('[data-f]');
      if (f) {
        const k = f.dataset.f;
        st[k] = f.checked ? st[k].concat(f.value) : st[k].filter(x => x !== f.value);
        st.shown = 24; render(); return;
      }
      if (e.target === sortSel) { st.sort = sortSel.value; st.shown = 24; renderResults(); }
    });
    el.addEventListener('click', e => {
      if (!all) return;
      const rm = e.target.closest('[data-rm]');
      if (rm) { st[rm.dataset.rm] = st[rm.dataset.rm].filter(x => x !== rm.dataset.v); st.shown = 24; render(); return; }
      if (e.target.closest('[data-more]')) { st.shown += 24; renderResults(); }
    });
  }

  /* ---------- Related products ---------- */
  function initRelated(el) {
    if (!el.dataset.url || el.children.length) return;
    fetch(el.dataset.url).then(r => (r.ok ? r.text() : '')).then(html => {
      if (!html) return;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(() => {});
  }

  /* ---------- Quote form: /pages/contact?product=<handle>&variant=<id> fills in the product ---------- */
  function initQuote(notes) {
    const params = new URLSearchParams(location.search), h = params.get('product');
    if (!h || notes.value.trim()) return;
    const fill = (title, extra, type) => {
      if (notes.value.trim()) return;
      notes.value = `Interested in: ${title}${extra ? ' (' + extra + ')' : ''}\n`;
      const size = $('select[name="contact[Booth size]"]');
      if (size && type === 'Island Exhibits') { const o = Array.from(size.options).find(x => /island/i.test(x.text)); if (o) size.value = o.value; }
    };
    fetch(`${ROOT}products/${encodeURIComponent(h)}.js`).then(r => (r.ok ? r.json() : null)).then(p => {
      if (!p) { fill(h.replace(/-/g, ' ')); return; }
      const v = p.variants.find(x => String(x.id) === params.get('variant'));
      fill(p.title, v && p.variants.length > 1 ? v.title + (v.sku ? ', ' + v.sku : '') : '', p.type);
    }).catch(() => fill(h.replace(/-/g, ' ')));
  }

  function init() {
    $$('[data-product]').forEach(initProduct);
    $$('[data-shop]').forEach(initShop);
    $$('[data-related]').forEach(initRelated);
    const notes = $('[data-quote-notes]'); if (notes) initQuote(notes);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', e => {
    $$('[data-product]', e.target).forEach(initProduct);
    $$('[data-shop]', e.target).forEach(initShop);
    $$('[data-related]', e.target).forEach(initRelated);
  });
})();
